import Link from "next/link";
import { useRouter } from "next/router";
import React, { useCallback } from "react";

import { Button } from "@/components/Buttons/index";
import { useModal } from "@/hooks";
import config from "@/lib/config";
import { idcLoginUrl, idcSignupUrl } from "@/lib/constants";
import loginStyles from "@/styles/Login.module.scss";
import processStyles from "@/styles/Process.module.scss";

import IdcSignUpModal from "../IdcSignupModal";

// ログイン画面1
export default function LoginForm(props) {
  const router = useRouter();
  const { showModal, hideModal } = useModal();
  const onClickHandle = useCallback((url) => {
    hideModal();
    props?.setIsSignupClicked(true);
    router.push(url);
  }, []);
  const showSignupModal = useCallback(() => {
    showModal(
      <IdcSignUpModal onClickHandle={() => onClickHandle(idcSignupUrl)} />,
      {
        closeButton: true,
        outerAreaClose: true,
        style: "dialogue",
      }
    );
  }, [onClickHandle]);
  return (
    <div className={loginStyles.contentWrapper}>
      <div className={loginStyles.loginSet}>
        <div className={`${loginStyles.formSection}`}>
          <div className={loginStyles.sectionInner} style={{ padding: "1em" }}>
            <p
              className={loginStyles.sectionTitle}
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              スカパー！メンバーズIDをお持ちの方
            </p>
            <br />
            <p className={loginStyles.button}>
              <Button
                onClick={() => onClickHandle(idcLoginUrl)}
                fontBold
                fillColor
                large
                largeFont
                fontFixed
              >
                スカパー！メンバーズIDでログイン
              </Button>
            </p>
            <p>※スカパー！メンバーズのサイトへ移動します</p>
          </div>
        </div>
        <hr style={{ width: "100%", borderColor: "#101010" }} />
        <div
          className={`${loginStyles.loginSection} ${loginStyles.formSection}`}
        >
          <div className={loginStyles.flexTitle}>
            <p className={loginStyles.sectionTitle}>
              スカパー！メンバーズIDをお持ちではない方
              <br />
            </p>
          </div>
          <div className={loginStyles.sectionInner}>
            <p className={loginStyles.button}>
              <Button
                onClick={showSignupModal}
                fontBold
                fillColor
                large
                largeFont
                fontFixed
              >
                スカパー！メンバーズID新規会員登録
              </Button>
            </p>
          </div>
          <div className={loginStyles.caption_white_left}>
            ※SPOOXのご利用にはスカパー！メンバーズIDが必要となり、SPOOX
            IDでのログインは出来なくなりました。
          </div>
          <div className={loginStyles.caption_left}>
            ※SPOOX
            IDをお持ちの方は、同じメールアドレスをスカパー！メンバーズIDとしてご登録ください。
          </div>
          <div className={processStyles.link}>
            お手続き方法詳細は
            <Link href={config.idc.membersIdInfo} className="underline">
              こちら
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
